import { render, staticRenderFns } from "./ShippingComponent.vue?vue&type=template&id=44c9941b&"
import script from "./ShippingComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports